import axios from "axios";

// Submissions are handled by Netlify Forms — there is no backend. Netlify picks
// up any POST to the site root whose body carries a `form-name` matching one of
// the hidden detection forms in public/index.html, stores it, and emails the
// notification address configured under Site configuration → Forms.
// Note: this only works on a deployed Netlify site (or `netlify dev`), not on
// the plain CRA dev server.
const encode = (data) =>
  Object.keys(data)
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(data[k] ?? "")}`)
    .join("&");

// `bot-field` is the honeypot declared on the detection forms: real submissions
// always send it empty, bots that fill it in get discarded by Netlify.
const submitForm = (formName, data) =>
  axios.post("/", encode({ "form-name": formName, "bot-field": "", ...data }), {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });

export const submitEmployer = (data) => submitForm("employer-enquiry", data);
export const submitCandidate = (data) => submitForm("candidate-profile", data);
export const submitContact = (data) => submitForm("contact", data);
